import { updateSmartList as _updateSmartList } from '@griply/services';
import {
  doc,
  getFirestore,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import { ID } from 'shared/types/id';
import { UpdateSmartList } from 'shared/types/smart-list';

export const updateSmartList = async (
  _uid: ID,
  smartList: UpdateSmartList,
): Promise<void> =>
  _updateSmartList({
    smartList,
    db: getFirestore(),
    doc,
    updateDoc,
    serverTimestamp,
  });
